// extracted by mini-css-extract-plugin
module.exports = {"container":"BodyContentFormatter-module__container--GdNTi","fluid":"BodyContentFormatter-module__fluid--ivjv7"};